<template>
    <div class="row">
        <div class="col m4">
            <label>Facultad</label>
            <select class="browser-default" v-model="codfac" @change="this.codcar = 0; getHorarios()">
                <option value="0">Todas</option>
                <option v-for="facultad in facultades" :key="facultad" :value="facultad.fac_codigo">{{ facultad.fac_nombre }}</option>
            </select>
        </div>
        <div class="col m4">
            <label>Carrera</label>
            <select class="browser-default" v-model="codcar" @change="getHorarios()">
                <option value="0">Todas</option>
                <option v-for="carrera in carreras_filter" :key="carrera" :value="carrera.car_codigo">{{ carrera.car_nombre }}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col m12">
            <table class="table tbl-condensed tbl-bordered striped" style="font-size: 12px;">
                <thead></thead>
                <tbody>
                    <template v-for="carrera in horarios" :key="carrera">
                        <tr>
                            <th colspan="6" class="center">{{ carrera.car_nombre }}</th>
                        </tr>
                        <template v-for="plan in carrera.ra_pla_planes" :key="plan">
                            <tr>
                                <td colspan="6" class="center">{{ plan.pla_nombre }}</td>
                            </tr>
                            <tr>
                                <th style="width: 5%;" class="center">Grupo</th>
                                <th style="width: 30%;" class="center">Materia</th>
                                <th style="width: 25%;" class="center">Docente</th>
                                <th style="width: 35%;" class="center">Detalle</th>
                                <th style="width: 5%;" class="center">Capacidad</th>
                                <th style="width: 5%;" class="center">Ver</th>
                            </tr>
                            <template v-for="horario in plan.ra_hor_horarios" :key="horario">
                                <tr>
                                    <td>{{ horario.hor_descripcion }}</td>
                                    <td>{{ horario.mat_codigo }} - {{ horario.mat_nombre }}</td>
                                    <td>{{ horario.emp_nombres_apellidos }}</td>
                                    <td>{{ horario.dho_descripcion }}</td>
                                    <td class="center">{{ horario.hor_max_alumnos }}</td>
                                    <td class="center"><a href="#!" @click="getInscritos(horario.hor_codigo, horario.emp_nombres_apellidos, horario.hor_descripcion, horario.dho_descripcion, horario.mat_codigo, plan.pla_codigo, horario.mat_nombre)"><i class="material-icons">list</i></a></td>
                                </tr>
                            </template>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal" id="modal-inscritos-movimiento">
        <div class="modal-content">
            <div class="row m0 p0">
                <div class="row m0 p0">
                    <div class="col m6">
                        <label>Grupo</label>
                        <p>{{ hor_descripcion }} | {{ codmat }} - {{ mat_nombre }}</p>
                    </div>
                    <div class="col m6">
                        <label>Docente</label>
                        <p>{{ emp_nombres_apellidos }}</p>
                    </div>
                </div>
                <div class="row m0 p0">
                    <div class="col m12">
                        <label>Grupo</label>
                        <p>{{ dho_descripcion }}</p>
                    </div>
                </div>
                <div class="row m0 p0">
                    <div class="card-panel grey lighten-3" v-show="this.inscritos.find(x=>x.per_selected) != undefined">
                        <div class="row m0 p0">
                            <div class="col m8">
                                <label>Horario</label>
                                <select class="browser-default" v-model="codhor_seleccionado" >
                                    <option value="0">Seleccione</option>
                                    <option :disabled="detalle.codigoHorario == codhor || detalle.capacidad <= detalle.inscritos" v-for="detalle in detalle_horarios" :key="detalle" :value="detalle.codigoHorario">{{ detalle.grupo }} | {{ detalle.horario }} | {{detalle.docente}} {{ detalle.inscritos }}/{{ detalle.capacidad }}</option>
                                </select>
                            </div>
                            <div class="col m4">
                                <br>
                                <button type="button" class="btn blue-ugb btn-small" :disabled="!allowMove()" @click="moverEstudiantes()">Mover Estudiantes</button>
                            </div>
                        </div>
                        <div class="row m0 p0" v-show="!allowMove() && codhor_seleccionado != 0">
                            <div class="col m12">
                                <label>Los estudiantes seleccionados exceden los cupos disponibles.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col m12">
                    <table class="table tbl-condensed tbl-bordered striped" style="font-size: 12px">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Carnet</th>
                                <th>Estudiante</th>
                                <th>Fecha</th>
                                <th><label><input type="checkbox" class="filled-in" id="chk_check_all" @change="seleccionarTodos($event)"><span></span></label></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(inscrito, index) in inscritos" :key="inscrito">
                                <td class="center">{{ index + 1 }}</td>
                                <td>{{ inscrito.per_carnet }}</td>
                                <td>{{ inscrito.per_apellidos_nombres }}</td>
                                <td class="center">{{ inscrito.mai_fecha }}</td>
                                <td class="center">
                                    <label v-show="!inscrito.per_moved"><input type="checkbox" class="filled-in" @change="getHorariosMateria()" v-model="inscrito.per_selected"><span></span></label>
                                    <i class="material-icons" v-show="inscrito.per_moved">check_circle</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import M from 'materialize-css'
    export default {
        data()
        {
            return {
                horarios: [],
                codcar: 0,
                codfac: 0,
                inscritos: [],
                modales: [],
                modal_inscritos: {},
                dho_descripcion: '',
                emp_nombres_apellidos: '',
                hor_descripcion: '',
                codmat: '',
                mat_nombre: '',
                codhor: 0,
                codpla: 0,
                detalle_horarios: [],
                codhor_seleccionado: 0,

                facultades: [],
                carreras: []
            }
        },
        async mounted()
        {
            var elems = document.querySelectorAll('.modal');
            this.modales = M.Modal.init(elems, null);
            await this.getHorarios();
            await this.getFacultades();
            await this.getCarreras();
        },
        methods: {
            async getFacultades()
            {
                await this.axios.get('/Facultades')
                .then(response => {
                    this.facultades = response.data;
                });
            },
            async getCarreras()
            {
                await this.axios.get('/Carreras/AllAllowed')
                .then(response => {
                    this.carreras = response.data;
                });
            },
            async getHorarios()
            {
                this.$root.startLoading();
                await this.axios.get('/Horarios/' + this.codfac + '/' + this.codcar)
                .then(response => {
                    this.horarios = response.data;
                });
                this.$root.stopLoading();
            },
            async getInscritos(codhor, docente, grupo, detalle, codmat, codpla, mat_nombre)
            {
                this.emp_nombres_apellidos = docente;
                this.hor_descripcion = grupo;
                this.dho_descripcion = detalle;
                this.codmat = codmat;
                this.codpla = codpla;
                this.mat_nombre = mat_nombre;
                this.codhor = codhor;
                this.inscritos = [];
                this.detalle_horarios = [];
                this.$root.startLoading();
                await this.axios.get('/Horarios/' + codhor + '/Inscritos')
                .then(response => {
                    if(response.status == 200)
                    {
                        this.inscritos = response.data.inscritos;
                        this.inscritos.forEach(x=>x.per_moved = false);                    
                    }
                    this.modal_inscritos = M.Modal.getInstance(document.querySelector('#modal-inscritos-movimiento'));
                    this.modal_inscritos.open(); 
                });
                this.$root.stopLoading();
            },
            async getHorariosMateria()
            {
                if(this.inscritos.filter(x=>x.per_selected).length == 0)
                {
                    this.detalle_horarios = [];
                }
                else
                {
                    if(this.detalle_horarios.length == 0)
                    {
                        this.$root.startLoading();
                        await this.axios.get('/Horarios/HorariosMateria/' + this.codmat + '/' + this.codpla)
                        .then(response => {
                            this.detalle_horarios = response.data;
                        });
                        this.$root.stopLoading();
                    }
                }
            },
            allowMove()
            {
                if(this.codhor_seleccionado == 0) return false;
                var horario = this.detalle_horarios.find(x=>x.codigoHorario == this.codhor_seleccionado);
                if(horario == undefined) return false;
                var seleccionados = this.inscritos.filter(x=>x.per_selected).length;
                if((horario.capacidad - horario.inscritos) < seleccionados)
                {
                    return false;
                }
                return true;
            },
            async moverEstudiantes()
            {
                if(!confirm('¿Está seguro que desea mover los estudiantes seleccionados?')) return false;
                var seleccionados = this.inscritos.filter(x=>x.per_selected);
                for(let i = 0; i <= seleccionados.length - 1; i++)
                {
                    this.$root.startLoading();
                    await this.axios.patch('/Estudiantes/MoverGrupo/' + seleccionados[i].mai_codigo + '/' + this.codhor + '/' + this.codhor_seleccionado)
                    .then(() => {
                        var index = this.inscritos.findIndex(x=>x.mai_codigo == seleccionados[i].mai_codigo);
                        this.inscritos[index].per_moved = true;
                        this.inscritos[index].per_selected = false;
                    })
                    .catch(error => {
                        M.toast({html: error.response.data.message});
                    });
                    this.$root.stopLoading();
                }
                this.detalle_horarios = [];
                await this.getHorariosMateria();
            },
            seleccionarTodos(event)
            {
                this.inscritos.forEach(x=>{
                    if(!x.per_moved)
                    {
                        x.per_selected = event.target.checked;
                    }
                });
            }
        },
        computed: {
            carreras_filter()
            {
                if(this.codfac == 0) return this.carreras;
                return this.carreras.filter(x=>x.car_codfac == this.codfac);
            }
        }
    }
</script>